"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteTenantChangeEventMutation = exports.useFetchTenantAuditLogQuery = exports.useFetchTenantHistoryQuery = exports.useUpdateTenantMutation = exports.useDeleteTenantMutation = exports.useMoveTenantLeasesMutation = exports.useLazyCheckTenantIdentifiersQuery = exports.useFetchTenantQuery = exports.useSearchTenantsQuery = exports.useFetchClientTenantsQuery = exports.useCreateTenantMutation = exports.tenantApi = void 0;
// api/tenantApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var billable_line_item_1 = require("./billable-line-item");
var custom_rate_1 = require("./custom-rate");
var meter_1 = require("./meter");
var occupancy_1 = require("./occupancy");
var tenant_invoice_1 = require("./tenant-invoice");
exports.tenantApi = (0, react_1.createApi)({
    reducerPath: "tenantApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["tenants"],
    endpoints: function (builder) { return ({
        createTenant: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/tenant/create",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["tenants"],
        }),
        fetchClientTenants: builder.query({
            query: function (obj) { return ({
                url: "/v1/tenant/all",
                method: "GET",
                params: {
                    clientId: obj.clientId,
                    areaId: obj.areaId,
                    partyType: obj.partyType,
                    isActive: obj.isActive,
                    deleted: obj.deleted,
                    page: obj.page,
                    limit: obj.limit,
                },
            }); },
            providesTags: ["tenants"],
        }),
        searchTenants: builder.query({
            query: function (obj) {
                var params = {
                    clientId: obj.clientId,
                    page: obj.page || 1,
                    limit: obj.limit || 10,
                };
                if (obj.search)
                    params.search = obj.search;
                if (obj.isActive !== undefined)
                    params.isActive = obj.isActive;
                if (obj.partyType)
                    params.partyType = obj.partyType;
                return {
                    url: "/v1/tenant/all",
                    method: "GET",
                    params: params,
                };
            },
            providesTags: ["tenants"],
        }),
        /**
         * ATOC-2 §7: is this registration/ID or VAT/tax number already used by another tenant?
         * Names are deliberately not identifiers — they change (marriage, merger).
         */
        checkTenantIdentifiers: builder.query({
            query: function (params) { return ({
                url: "/v1/tenant/check-identifiers",
                method: "GET",
                params: params,
            }); },
        }),
        /*
         * ATOC-2 §7: consolidate a duplicate tenant by moving its leases onto the one that keeps the
         * identity.
         *
         * A merge rewrites occupancies as well as tenants, and those live in a DIFFERENT RTK slice
         * (`occupancyApi`), which `invalidatesTags` here cannot reach — tags are scoped per slice. Leaving
         * it at that made the tenants list lie after a merge: the emptied record still showed as Active
         * with its old area, and the destination still showed its old lease count, because the lease data
         * came from a cache nothing had invalidated. So the occupancy cache is invalidated explicitly once
         * the mutation succeeds.
         */
        moveTenantLeases: builder.mutation({
            query: function (body) { return ({
                url: "/v1/tenant/move-leases",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: ["tenants"],
            onQueryStarted: function (_arg_1, _a) {
                return __awaiter(this, arguments, void 0, function (_arg, _b) {
                    var _c;
                    var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                _d.sent();
                                // One dispatch per slice the merge actually rewrites. Anything left out keeps serving the
                                // pre-merge answer until the user reloads by hand, which is how the tenants list came to show
                                // an emptied record as Active holding a lease that had already moved.
                                dispatch(occupancy_1.occupancyApi.util.invalidateTags(["occupancies"]));
                                dispatch(meter_1.meterApi.util.invalidateTags(["meters"]));
                                dispatch(tenant_invoice_1.tenantInvoiceApi.util.invalidateTags(["tenantInvoices"]));
                                dispatch(custom_rate_1.customRateApi.util.invalidateTags(["customRates"]));
                                dispatch(billable_line_item_1.billableLineItemApi.util.invalidateTags(["billableLineItems"]));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        fetchTenant: builder.query({
            query: function (tenantId) { return ({
                url: "/v1/tenant/fetch",
                method: "GET",
                params: {
                    _id: tenantId,
                },
            }); },
            providesTags: ["tenants"],
        }),
        fetchActiveTenantForSpecificArea: builder.query({
            query: function (areaId) { return ({
                url: "/v1/tenant/by-area",
                method: "GET",
                params: {
                    areaId: areaId,
                },
            }); },
            providesTags: ["tenants"],
        }),
        updateTenant: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/tenant/update",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["tenants"],
        }),
        deleteTenant: builder.mutation({
            query: function (_a) {
                var tenantId = _a.tenantId, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/tenant/remove",
                    method: "DELETE",
                    params: __assign({ _id: tenantId, performedBy: performedBy }, (reason ? { reason: reason } : {})),
                });
            },
            invalidatesTags: ["tenants"],
        }),
        fetchTenantHistory: builder.query({
            query: function (tenantId) { return ({
                url: "/v1/tenant/history",
                method: "GET",
                params: { _id: tenantId },
            }); },
            providesTags: function (_result, _err, tenantId) { return [{ type: "tenants", id: "history:".concat(tenantId) }]; },
        }),
        fetchTenantAuditLog: builder.query({
            query: function (_a) {
                var tenantId = _a.tenantId, action = _a.action, includeDeleted = _a.includeDeleted;
                return ({
                    url: "/v1/tenant/audit-log",
                    method: "GET",
                    params: __assign(__assign({ _id: tenantId }, (action ? { action: action } : {})), (includeDeleted ? { includeDeleted: true } : {})),
                });
            },
            providesTags: function (_result, _err, arg) { return [{ type: "tenants", id: "audit:".concat(arg.tenantId) }]; },
        }),
        deleteTenantChangeEvent: builder.mutation({
            query: function (_a) {
                var eventId = _a.eventId, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/tenant/audit-log/event",
                    method: "DELETE",
                    body: { eventId: eventId, performedBy: performedBy, reason: reason },
                });
            },
            invalidatesTags: function (_result, _err, arg) { return [
                { type: "tenants", id: "audit:".concat(arg.tenantId) },
                { type: "tenants", id: "history:".concat(arg.tenantId) },
            ]; },
        }),
    }); },
});
exports.useCreateTenantMutation = exports.tenantApi.useCreateTenantMutation, exports.useFetchClientTenantsQuery = exports.tenantApi.useFetchClientTenantsQuery, exports.useSearchTenantsQuery = exports.tenantApi.useSearchTenantsQuery, exports.useFetchTenantQuery = exports.tenantApi.useFetchTenantQuery, exports.useLazyCheckTenantIdentifiersQuery = exports.tenantApi.useLazyCheckTenantIdentifiersQuery, exports.useMoveTenantLeasesMutation = exports.tenantApi.useMoveTenantLeasesMutation, exports.useDeleteTenantMutation = exports.tenantApi.useDeleteTenantMutation, exports.useUpdateTenantMutation = exports.tenantApi.useUpdateTenantMutation, exports.useFetchTenantHistoryQuery = exports.tenantApi.useFetchTenantHistoryQuery, exports.useFetchTenantAuditLogQuery = exports.tenantApi.useFetchTenantAuditLogQuery, exports.useDeleteTenantChangeEventMutation = exports.tenantApi.useDeleteTenantChangeEventMutation;
